import React from 'react';
import './AboutUsSection.css';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import AboutSectionImg from '../../utils/images/about_us_section.webp';

function AboutUsSection() {
  return (
    <div className="container my-5">
        <div className="flex-column-reverse flex-lg-row row">
            <motion.div 
                className="col-lg-6 d-flex justify-content-center"
                initial={{ opacity: 0, x: -300 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
            >
                <img src={AboutSectionImg} className='about-section-img img-fluid mt-5 mt-lg-0 shadow' alt="about us" />
            </motion.div>
            <motion.div 
                className="col-lg-6 d-flex flex-column justify-content-center"
                initial={{ opacity: 0, x: 350 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
            >
                <h2 className='text-uppercase fw-bold fs-1 mb-4 mb-lg-5'>Sobre NÓS</h2>
                <p>A nossa missão é reunir as pessoas em torno de pratos meticulosamente elaborados que destacam os melhores ingredientes locais, preparados com um toque criativo. Desde carnes suculentas a opções vegetarianas vibrantes, cada item do nosso menu é cuidadosamente elaborado para satisfazer todos os paladares. </p>
                <p className='mb-4 mb-lg-5'>O nosso ambiente caloroso e acolhedor, aliado a um serviço excecional, fazem do Om Grill o local perfeito para reuniões, celebrações ou uma refeição casual. Junte-se a nós para saborear a arte de grelhar e deixe que a nossa viagem culinária desperte o seu paladar!</p>
                <Link to='/about'>
                    <button type='button' className='btn btn-dark btn-lg rounded-0 text-capitalize shadow'>Mais detalhes</button>
                </Link>
            </motion.div>
        </div>
    </div>
  )
}

export default AboutUsSection;